export const SET_SCHED_TASK_EXPORTS_ENTITY = 'setScheduledTaskExportsByEntity';
export const SET_SCHED_TASK_EXPORTS = 'setScheduledTaskExports';
export const SET_SCHED_TASK_EXPORTS_OUTPUTS = 'setScheduledTaskExportsOutputs';
export const SAVE_SCHED_TASK_EXPORT = 'saveScheduledTaskExport';
export const SET_SCHED_TASK_CUSTOM_ERROR = 'setCustomError';
